// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"221":"8d56f5f22b5852bf8e3c","1125":"a96fad535ba5547de058","1455":"de5c248c6858f774c765","1852":"86e88f793b922b2b3858","8346":"bc8155e639bd2d95d48d","9985":"5a0ef02d6a6ffce58505"}[chunkId] + ".chunk.js";
};